import React, {useContext} from 'react';
import styled from 'styled-components';
import {Price} from '../Price';
import {Flags} from '../Flags';
import {Breakpoints} from '@volkswagen-onehub/components-core';
import {
  ResultsView,
  ResultsViewContext,
} from '../../../utils/results-view-context';
import { VehicleContext } from '../../../utils/vehicle-context';
import { VehicleData } from '../../../types';

interface CardSubHeadContainerInterface {
  view: ResultsView;
}

const CardSubHeadContainer = styled.div<CardSubHeadContainerInterface>`
  grid-area: price;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  row-gap: 5px;
  margin-left: 4px;

  @media (min-width: ${Breakpoints.b960}px) {
    align-items: ${(props) =>
      props.view === ResultsView.LIST ? 'flex-start' : 'flex-end'};
  }
`;

const CardSubHead : React.FC<{sold?: boolean;}> = () => {
  const view = useContext(ResultsViewContext).value;
  const vehicle = useContext(VehicleContext) as VehicleData;
  const sold = vehicle.deleted

  return (
    <CardSubHeadContainer view={view}>
      <Price />
      {!sold && <Flags />}
    </CardSubHeadContainer>
  );
};

export default CardSubHead;
